import * as React from "react";
import { RouteStore } from "bernie-core";
import { observer, inject } from "mobx-react";
import { UitkLayoutFlexItem, UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkCard, UitkCardContent, UitkCardMedia, UitkCardLink } from "uitk-react-cards";
import { WindowWithChatbot, WebChatObject, ClientChatbotStore } from "src/stores/chatbotStore/ClientChatbotStore";
import { UitkIcon } from "uitk-react-icons";
import { BlossomCustomerNotification } from "__generated__/api";
import { sendAnalytics } from "./NotificationQueryUtils";
import Links = BlossomCustomerNotification.Links;
import Actions = BlossomCustomerNotification.Actions;

export interface DialogActionProps {
  chatbot?: ClientChatbotStore;
  routeStore?: RouteStore;
  link?: Links;
  analyticsCallback?: (rfrr: string, linkName: string | null) => void;
}

export const DialogAction: React.FunctionComponent<DialogActionProps> = inject(
  "chatbot",
  "routeStore"
)(
  observer((props: DialogActionProps) => {
    const { link, analyticsCallback, chatbot, routeStore } = props;
    const chatbotWindowObject: WebChatObject | undefined = chatbot!.getWebChatObject(window as WindowWithChatbot);
    const chatBotId = "openChatbot";
    const [initialized, setInitialized] = React.useState<boolean>(false);
    React.useEffect(() => {
      (async () => {
        setInitialized(await chatbotWindowObject?.isInitialized);
      })();
    }, []);
    const useChatbot = link?.id === chatBotId && initialized;
    const actionHref = useChatbot ? "#" : link?.url;
    /* istanbul ignore next */
    const onChatbotClick = (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      if (analyticsCallback) {
        sendAnalytics(link?.actions as Actions[], analyticsCallback);
      }
      routeStore!.closeDialog();
      if (useChatbot) {
        if (chatbotWindowObject) {
          chatbotWindowObject.openChatWidget();
        }
      }
    };

    /* istanbul ignore next */
    const onLinkClick = (e: React.MouseEvent<HTMLElement>) => {
      if (analyticsCallback) {
        sendAnalytics(link?.actions as Actions[], analyticsCallback);
      }
    };

    return (
      <UitkLayoutFlexItem minWidth="full_width">
        <UitkCard withBorder={true}>
          <UitkCardContent className={"all-y-padding-three all-x-padding-three"}>
            <UitkLayoutFlex justifyContent="space-between" alignItems="center" className="cardContentContainer">
              <UitkLayoutFlexItem>
                <div>
                  <p className="uitk-type-medium">{link?.text}</p>
                </div>
              </UitkLayoutFlexItem>
              <UitkCardMedia pxWidth={30} className="">
                <UitkIcon name="chevron_right" />
              </UitkCardMedia>
            </UitkLayoutFlex>
          </UitkCardContent>
          <UitkCardLink>
            {useChatbot ? (
              <a onClick={onChatbotClick} href={actionHref}>
                {link?.text}
              </a>
            ) : (
              <a onClick={onLinkClick} href={actionHref}>
                {link?.text}
              </a>
            )}
          </UitkCardLink>
        </UitkCard>
      </UitkLayoutFlexItem>
    );
  })
);
